import qs from 'qs'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import { Category } from '@/types/Literal'

const useCategory = () => {
  const { search } = useLocation()
  const query = qs.parse(search, {
    ignoreQueryPrefix: true,
  })

  const baseParams: { category: Category } = {
    category: 'ALL',
  }

  const category = (query.category as Category) ?? baseParams.category

  const setCategory = (value: Category) => {
    const queryString = qs.stringify({ category: value }, { arrayFormat: 'repeat' })
    navigate(`/?${queryString}`, { replace: true })
  }

  return [category, setCategory] as const
}

export default useCategory
